module.exports = __webpack_public_path__ + "files/diagonal.98a2322c360b5f6b385517f4d4657202.png";